import React, { useMemo } from 'react';

import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import entryPoint from './storageHardLimit.entrypoint';

export function StorageHardLimitModal(): React.JSX.Element {
	const modalProps = useMemo(() => ({ width: 968, height: 520 }), []);

	return (
		<ModalEntryPoint modalProps={modalProps} entryPoint={entryPoint} dialogConfig={DIALOG_CONFIG} />
	);
}
